import { render, staticRenderFns } from "./MoveTaskWindow.vue?vue&type=template&id=24431fe6&"
import script from "./MoveTaskWindow.vue?vue&type=script&lang=js&"
export * from "./MoveTaskWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports